import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { Box, Dialog } from '@mui/material';

/** Redux Packages. */
import { useDispatch } from 'react-redux';

/** Redux Reducers. */
import { setSnackbar } from 'shared/store/slices/snackBarSlice';

/** Internal Components. */
import { createSocketData } from 'shared/lib/fetchSocket';
import InputField, { DateTimeField } from 'shared/ui/InputForm';
import { PaperComponent } from 'shared/ui/DraggableDialog';
import DialogHeader from 'shared/ui/DialogHeader';
import validateFields from 'shared/lib/validateFields';

const forms = [
    {
        id: 1,
        title: 'OPUS Reference#',
        type: 'TextField',
        key: 'title',
    },
    {
        id: 2,
        title: 'Description',
        type: 'TextField',
        key: 'description',
    },
    {
        id: 3,
        title: 'Due Date',
        type: 'DateTime',
        key: 'due_date',
    },
];

/** Initial form data. */
const initState = {
    title: '',
    description: '',
    due_date: null,
    status: false,
};

/** Initial input validator. */
const initValidator = {
    title: false,
    description: false,
    due_date: false,
};
export default function TodoReminder(props) {
    /** Get props from TodoPanel.js. */
    const { reminderOpen, setReminderOpen, setReminderList } = props;

    /** Get the dispatch function from Redux to send actions to the store. */
    const dispatch = useDispatch();

    /** State for reminderform data. */
    const [formData, setFormData] = useState(initState);
    /** State for validate any inputs are empty. */
    const [validator, setValidator] = useState(initValidator);

    /** Handle to close a dialog. */
    const handleReminderClose = () => {
        setFormData(initState);
        setValidator(initValidator);
        setReminderOpen(false);
    };

    /** Handler to update form data. */
    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    /** Handler to submit form data. */
    const handleReminderSubmit = () => {
        const fieldsToValidate = {
            title: formData.title,
            description: formData.description,
            due_date: formData.due_date,
        };

        const isValid = validateFields(fieldsToValidate, setValidator);
        if (!isValid) {
            dispatch(
                setSnackbar({
                    open: true,
                    message: 'Please check the input fields.',
                    severity: 'warning',
                })
            );
            return;
        }
        createSocketData(dispatch, '', 'row', 'il_alert', null, formData, (receivedData) => {
            setReminderList((prev) => [...prev, receivedData.data]);
            handleReminderClose();
        });
    };

    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            open={reminderOpen}
            onClose={handleReminderClose}
            PaperComponent={PaperComponent}
            PaperProps={{
                sx: {
                    borderRadius: '18px',
                },
            }}
        >
            <Box sx={{ height: 230, display: 'flex', flexDirection: 'column' }}>
                <DialogHeader
                    cursor
                    title={'NEW REMINDERS'}
                    onClose={handleReminderClose}
                    onSave={handleReminderSubmit}
                />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                    }}
                >
                    {forms.map((form) => {
                        return form.type === 'TextField' ? (
                            <InputField
                                key={form.id}
                                label={form.title}
                                name={form.key}
                                value={formData[form.key]}
                                onChange={handleFormChange}
                                sx={{ mb: 1 }}
                                labelStyle={{ width: '120px' }}
                                inputStyle={{ width: '300px' }}
                                error={validator[form.key]}
                            />
                        ) : form.type === 'DateTime' ? (
                            <DateTimeField
                                key={form.id}
                                label={form.title}
                                name={form.key}
                                value={formData[form.key]}
                                onChange={handleFormChange}
                                width={'300px'}
                                sx={{ mb: 1 }}
                                labelStyle={{ width: '120px' }}
                                additional={{
                                    disablePast: true,
                                }}
                            />
                        ) : null;
                    })}
                </Box>
            </Box>
        </Dialog>
    );
}
